import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateCreditReturnInvoiceStepperComponent } from './create-credit-return-invoice-stepper.component';
import { ReturnSaveStepModule } from '../create-return-invoice-stepper/return-save-step/return-save-step.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { PosStepperModule } from 'src/app/shared/pos-stepper/pos-stepper.module';
import { ReturnContractStepModule } from './return-contract-step/return-contract-step.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [CreateCreditReturnInvoiceStepperComponent],
  imports: [
    CommonModule,
    PosStepperModule,
    CdkStepperModule,
    ReturnSaveStepModule,
    ReturnContractStepModule,
    ReactiveFormsModule
  ],
  exports: [CreateCreditReturnInvoiceStepperComponent]
})
export class CreateCreditReturnInvoiceStepperModule { }
